import { useEffect } from "react";

export const Seo = ({ title, description, jsonLd }) => {
  const json = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    if (title) document.title = title;
    let meta;
    if (description) {
      meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    let script;
    if (json) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = json;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, json]);
  return null;
};
